/* ═══════════════════════════════════════════════════════════
   LJDA PDP — JavaScript
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── PASO 2: Sticky CTA Mobile ── */
  function initStickyCta() {
    var cta = document.getElementById('ljda-sticky-cta');
    if (!cta) return;

    // Observar el formulario principal de add-to-cart
    var atcForm = document.querySelector('form[action$="/cart/add"]');
    if (!atcForm) return;

    var isVisible = false;

    function setVisible(show) {
      if (isVisible === show) return;
      isVisible = show;
      cta.classList.toggle('ljda-sticky-cta--visible', show);
      cta.setAttribute('aria-hidden', show ? 'false' : 'true');
      // Añade padding al body para que el footer no quede tapado
      document.body.style.paddingBottom = show
        ? 'calc(64px + env(safe-area-inset-bottom, 0px))'
        : '';
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -20px 0px', threshold: 0 }
    );

    observer.observe(atcForm);

    // Tap: scroll suave al ATC principal
    var btn = document.getElementById('ljda-sticky-cta-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        atcForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCta);
  } else {
    initStickyCta();
  }
})();
